import {
    createTheme,
    Dropdown,
    DropdownDivider,
    DropdownItem,
    DropdownItemProps,
} from 'flowbite-react';
import { IconHelp } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import AboutThisPageLink from './AboutThisPageLink';
import { IconExternalLink } from '@tabler/icons-react';
import { Fragment } from 'react';

const theme = createTheme({
    dropdown: {
        floating: {
            item: {
                base: 'focus:bg-gray-100 focus:outline-hidden font-medium gap-1.5 hover:bg-gray-100 inline-flex items-center px-4 py-2 text-gray-900 text-left text-sm w-full visited:text-gray-900',
            },
        },
        inlineWrapper:
            'rounded-full enabled:hover:bg-gray-700 p-2 text-gray-200 hidden xxl:inline-block',
    },
}).dropdown;

interface DropdownOption {
    textPath: string;
    props: DropdownItemProps<'a'>;
    isDivided?: boolean;
}

export const STATIC_HELP_DROPDOWN_OPTIONS: DropdownOption[] = [
    {
        props: {
            href: 'https://support.bigleaf.net/',
            target: '_blank',
        },
        textPath: 'layout:help-menu:help',
    },
    {
        props: {
            href: 'https://support.bigleaf.net/hc/en-us/requests/new?ticket_form_id=318967',
            target: '_blank',
        },
        textPath: 'layout:help-menu:submit',
    },
    {
        props: {
            href: 'https://status.bigleaf.net/',
            target: '_blank',
        },
        textPath: 'layout:help-menu:status',
        isDivided: true,
    },
    {
        props: {
            href: 'https://secure.versapay.com/choose_supplier',
            target: '_blank',
        },
        textPath: 'layout:help-menu:versa_pay',
    },
    {
        props: {
            href: 'https://partner.bigleaf.net/',
            target: '_blank',
        },
        textPath: 'layout:help-menu:partner',
    },
];

const HelpDropdown = () => {
    const { t } = useTranslation();

    return (
        <Dropdown
            theme={theme}
            inline
            color="light"
            placement="bottom-end"
            arrowIcon={false}
            label={
                <IconHelp
                    size={32}
                    aria-label={t('layout:help-menu:aria-label')}
                    stroke={1.5}
                />
            }
        >
            <AboutThisPageLink dropdown={true} />
            {STATIC_HELP_DROPDOWN_OPTIONS.map(
                ({ props, textPath, isDivided }) => (
                    <Fragment key={textPath}>
                        <DropdownItem rel="noopener noreferrer" {...props}>
                            {t(textPath)}
                            <IconExternalLink size={20} />
                        </DropdownItem>
                        {isDivided && <DropdownDivider />}
                    </Fragment>
                )
            )}
        </Dropdown>
    );
};

export default HelpDropdown;
